import React from "react"

import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { isEmpty } from "lodash-es"

interface RestrictionModalProps {
  imageSrc: any
  title: string
  content: string[]
  buttonLabel: string
  onButtonClick: () => void
}

const RestrictionModal: React.FC<RestrictionModalProps> = ({
  imageSrc,
  title,
  content,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <div className="flex justify-center  p-4 overflow-hidden items-center absolute z-50  bottom-0 left-0 top-0 right-0 blurTypeThickDark">
      <div className="flex-1 max-w-screen-xl">
        <div className="flex rounded-xl md:p-8 lg:p-12 flex-col lg:flex-row flex-wrap">
          <div className="flex-1 flex items-center justify-center">
            <div className="flex items-center justify-center">
              <img
                src={imageSrc}
                className="max-w-xs md:max-w-sm p-8 lg:p-0"
                alt="Event Image"
              />
            </div>
          </div>
          <div className="flex-1">
            <FancyText className="text-[36px] md:text-[58px] font-bold text-center text-secondary ">
              {title}
            </FancyText>
            <p className="text-textPrimary text-lg font-[500] mt-[40px]">
              {!isEmpty(content) &&
                content?.map((item) => {
                  return (
                    <>
                      <p>{item}</p>
                      <br />
                    </>
                  )
                })}
            </p>

            <div className="flex w-full items-center justify-center mt-8">
              <SolidBtn
                onClick={onButtonClick}
                className="px-[70px] py-[15px] rounded-[100px]"
              >
                {buttonLabel}
              </SolidBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RestrictionModal
